import React from "react";
import { LayoutProps } from "./types";
import ContentSection from "./ContentSection";
import Content from "../Content";
import cx from "classnames";

const Layout: React.FC<LayoutProps> = ({
  data,
  heading,
  align,
  preview = false,
  onDark,
  depth = 0,
}) => {
  if (data.method === "grid") {
    return (
      <ContentSection
        className={cx("my-5 w-full", `align-${align || "left"}`)}
        type={data.type}
        preview={preview}
      >
        {heading}
        <div
          className={`grid grid-cols-1 md:grid-cols-${
            data.grid_columns ?? 3
          } gap-4`}
        >
          {data.collections.map((collection, index) => (
            <div key={index} className="min-w-0">
              <Content
                data={collection.blocks}
                depth={depth + 1}
                align={collection.align}
                preview={preview}
                onDark={onDark}
              />
            </div>
          ))}
        </div>
      </ContentSection>
    );
  }

  return (
    <ContentSection
      className={cx("my-5 w-full", `align-${align || "left"}`)}
      type={data.type}
      preview={preview}
    >
      {heading}
      <div
        className="flex flex-wrap gap-4 md:gap-10 w-full"
        style={{ width: "100%" }}
      >
        {Array.isArray(data.collections) &&
          data.collections.map((collection, index) => (
            <div
              key={index}
              className={cx(
                "w-full md:flex-1 min-w-0 md:min-w-[200px]",
                collection.align ? `align-${collection.align}` : "align-left"
              )}
            >
              <Content
                data={collection.blocks}
                depth={depth + 1}
                align={collection.align}
                preview={preview}
                onDark={onDark}
              />
            </div>
          ))}
      </div>
    </ContentSection>
  );
};

export default Layout;
